@use '../../scss/utility';
@use './avatar/avatar';
@use './icon/icon';
@use './label/label';

:host {
  --color: var(--wb-grey-45);

  display: inline-block;
  -webkit-tap-highlight-color: transparent;
}

.cta {
  display: flex;
  justify-content: center;
  align-items: center;
  height: utility.wb-pixel-to-rem(36px);
  color: var(--color);
  background-color: inherit;
  padding: 0;
  border: none;
  text-decoration: none;
  cursor: pointer;
}

.avatar,
.icon,
.label,
.chevron {
  position: relative;
  color: var(--color);
}

.notification {
  position: absolute;
  inset-block-start: utility.wb-pixel-to-rem(2px);
  inset-inline-end: 0;
  height: utility.wb-pixel-to-rem(8px);
  width: utility.wb-pixel-to-rem(8px);
  background-color: var(--wb-blue-45);
  border-radius: 50%;
}

:host(:hover),
:host(:focus) {
  --color: var(--color-black);
}

:host(:focus-visible) {
  outline: utility.wb-pixel-to-rem(1px) solid var(--wb-blue-45);
  outline-offset: utility.wb-pixel-to-rem(1px);
}

:host([theme='dark']:hover),
:host([theme='dark']:focus) {
  --color: var(--wb-white);
}
